import { computed, useSlots, Fragment, watch } from 'vue'
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/valibot'
import { object, forward, partialCheck, pipe } from 'valibot'
import * as validators from '@/helpers/validationHelpers.js'
import { isEqual } from 'lodash' // eslint-disable-line

export const useFormValidation = (props, emit) => {
  const slots = useSlots()
  const fields = computed(() => {
    let nodes = slots.default?.() || []
    nodes = nodes[0]?.type === Fragment ? nodes[0].children : nodes
    if (!nodes) return [] // Bail out early
    return nodes.map(n => { // .filter(f => f.props.type !== 'checkbox')
      const field = { name: n.key }
      if (n.props.sameAs) {
        field.sameAs = n.props.sameAs
        if (n.props.sameAsErrorMessage) field.sameAsErrorMessage = n.props.sameAsErrorMessage
        else field.sameAsErrorMessage = 'Values do not match.'
      }
      return field
    })
  })

  const validationSchema = computed(() => {
    const compareWithSelected = fields.value.find(f => f.sameAs)
    const selectForCompare = fields.value.find(f => f.name === compareWithSelected?.sameAs)?.name

    const usedValidators = fields.value.reduce((acc, field) => {
      acc[field.name] = validators[field.name]
      return acc
    }, {})

    const schemas = [object(usedValidators)]

    if (selectForCompare && compareWithSelected) {
      const compareSchema = forward(
        partialCheck(
          [[selectForCompare], [compareWithSelected.name]],
          input => input[selectForCompare] === input[compareWithSelected.name],
          compareWithSelected.sameAsErrorMessage
        ),
        [compareWithSelected.name]
      )
      schemas.push(compareSchema)
    }

    const Schema = pipe(...schemas)

    return toTypedSchema(Schema)
  })

  const { handleSubmit, resetForm: onReset, meta, errors, values, initialValues } = useForm({ validationSchema }) // eslint-disable-line

  const isDirty = computed(() => meta.value.dirty)
  const isValid = computed(() => meta.value.valid)
  const onSubmit = handleSubmit(data => emit('submit', data))

  watch(() => values, val => {
    // if (isEqual(val, initialValues.value)) onReset()
  }, { deep: true })

  return {
    isDirty,
    isValid,
    onReset,
    onSubmit,
    errors
  }
}
